module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-get-start-form-section"
  }, [_c('div', {
    staticClass: "custom-get-start-form-section__background"
  }, [_c('div', {
    staticClass: "custom-get-start-form-section__container"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props.intro
    }
  }), _c('div', {
    staticClass: "custom-get-start-form-section__row"
  }, [_c('div', {
    staticClass: "custom-get-start-form-section__col",
    domProps: {
      "innerHTML": _vm._s(_vm.props.col_left.content)
    }
  }), _c('div', {
    staticClass: "custom-get-start-form-section__col"
  }, _vm._l((_vm.props.col_right.form_list), function(form, i) {
    return _c('div', {
      staticClass: "custom-get-start-form-section__form-list"
    }, [_c('div', {
      staticClass: "custom-get-start-form-section__tab"
    }, [_vm._v(_vm._s(form.label))]), _c('div', {
      staticClass: "custom-get-start-form-section__link"
    }, [_c('a', {
      attrs: {
        "href": form.href,
        "target": "_blank"
      }
    }, [_vm._v("PDF")])])])
  }))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d20f218","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-get-start-form-section/custom-get-start-form-section.pug
// module id = 589
// module chunks = 1